
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/komodo-wallet/mobile/restore-a-wallet",
      function () {
        return require("private-next-pages/docs/komodo-wallet/mobile/restore-a-wallet/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/komodo-wallet/mobile/restore-a-wallet"])
      });
    }
  